import React from 'react';
import EArchiveGroupActionsWrapper from '../EArchiveGroupActionsWrapper';
import { GroupActionItem } from '../../../../Interfaces/GroupActionItem.interface';
import EArchiveGroupsListDeleteModal from '../../../EArchiveGroupsListWrapper/EArchiveGroupsListDeleteModal/EArchiveGroupsListDeleteModal';
import {
	UpdateGroupInput,
	useDeleteGroupMutation,
	useUpdateGroupMutation,
} from '../../../../../../graphql/graphql';
import useNotification from '../../../../../../Hooks/useNotification.hook';
import useApiClient from '../../../../../Base/Hooks/useApiClient';
import EArchiveGroupSettingsActionsUpdateModal from './EArchiveGroupSettingsActionsUpdateModal';

interface Props {
	groupId: string;
	onUpdate: () => void;
	onDelete: () => void;
}

const EArchiveGroupSettingsActions = ({
	groupId,
	onUpdate,
	onDelete,
}: Props) => {
	const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
	const [isUpdateModalOpen, setIsUpdateModalOpen] = React.useState(false);
	const [updateGroup] = useUpdateGroupMutation();
	const [deleteGroup] = useDeleteGroupMutation();
	const { showNotificationSuccess, showNotificationAlert } = useNotification();
	const { displayGQLError } = useApiClient();

	const handleUpdateGroup = async (values: UpdateGroupInput) => {
		try {
			const response = await updateGroup({
				where: { id: groupId },
				input: values,
			});

			if ('data' in response) {
				showNotificationSuccess({
					content: 'component.eArchive.group.settings.changeGroupNameSuccess',
				});
				setIsUpdateModalOpen(false);
				onUpdate();
			} else {
				displayGQLError(response);
			}
		} catch (error) {
			showNotificationAlert({
				content: 'base.shared.warningBug',
			});
		}
	};

	const handleDeleteGroup = async () => {
		try {
			const response = await deleteGroup({
				where: { id: groupId },
			});

			if ('data' in response) {
				showNotificationSuccess({
					content: 'component.eArchive.groups.deleteGroupSuccess',
				});
				setIsDeleteModalOpen(false);
				onDelete();
			} else {
				displayGQLError(response);
			}
		} catch (error) {
			showNotificationAlert({
				content: 'base.shared.waringBug',
			});
		}
	};

	const items: GroupActionItem[] = [
		{
			title: 'component.eArchive.group.settings.changeGroupName',
			onClick: () => setIsUpdateModalOpen(true),
		},
		{
			title: 'component.eArchive.group.settings.deleteGroup',
			onClick: () => setIsDeleteModalOpen(true),
		},
	];

	return (
		<>
			<EArchiveGroupActionsWrapper items={items} />
			{isUpdateModalOpen && (
				<EArchiveGroupSettingsActionsUpdateModal
					isOpen
					groupId={groupId}
					onSubmit={handleUpdateGroup}
					onClose={() => setIsUpdateModalOpen(false)}
				/>
			)}
			{isDeleteModalOpen && (
				<EArchiveGroupsListDeleteModal
					isOpen
					onSubmit={handleDeleteGroup}
					onClose={() => setIsDeleteModalOpen(false)}
				/>
			)}
		</>
	);
};

export default EArchiveGroupSettingsActions;
